/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ monthly_price: NonNullable<unknown> }} Subscription_Footer_MonthlyInputs */

const en_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} per month, cancel anytime.`)
};

const ar_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} شهريًا، يمكنك الإلغاء في أي وقت.`)
};

const de_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} pro Monat, jederzeit kündbar.`)
};

const es_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} al mes, cancelación en cualquier momento.`)
};

const fr_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} par mois, résiliable à tout moment.`)
};

const it_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} al mese, annulla in qualsiasi momento.`)
};

const ja_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/月、いつでもキャンセル可能です。`)
};

const ko_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`매월 ${i?.monthly_price}, 언제든 취소할 수 있어요.`)
};

const pt_br_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} por mês. Cancele a qualquer momento.`)
};

const ru_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} в месяц, отмена в любое время.`)
};

const th_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price} ต่อเดือน ยกเลิกได้ตลอดเวลา`)
};

const tr_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aylık ${i?.monthly_price}, istediğin zaman iptal edebilirsin.`)
};

const zh_cn_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每月 ${i?.monthly_price}，随时可以取消。`)
};

const zh_tw_subscription_footer_monthly = /** @type {(inputs: Subscription_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每月 ${i?.monthly_price}，隨時可以取消。`)
};

/**
* | output |
* | --- |
* | "{monthly_price} per month, cancel anytime." |
*
* @param {Subscription_Footer_MonthlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_footer_monthly = /** @type {((inputs: Subscription_Footer_MonthlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Footer_MonthlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_footer_monthly(inputs)
	if (locale === "ar") return ar_subscription_footer_monthly(inputs)
	if (locale === "de") return de_subscription_footer_monthly(inputs)
	if (locale === "es") return es_subscription_footer_monthly(inputs)
	if (locale === "fr") return fr_subscription_footer_monthly(inputs)
	if (locale === "it") return it_subscription_footer_monthly(inputs)
	if (locale === "ja") return ja_subscription_footer_monthly(inputs)
	if (locale === "ko") return ko_subscription_footer_monthly(inputs)
	if (locale === "pt_br") return pt_br_subscription_footer_monthly(inputs)
	if (locale === "ru") return ru_subscription_footer_monthly(inputs)
	if (locale === "th") return th_subscription_footer_monthly(inputs)
	if (locale === "tr") return tr_subscription_footer_monthly(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_footer_monthly(inputs)
	return zh_tw_subscription_footer_monthly(inputs)
});